import { createAsyncThunk } from "@reduxjs/toolkit";
import { R_getUserInfo } from "api/user/userService";

export const T_getUserInfo = createAsyncThunk('user/getInfo', async (_, thunkAPI) => {
    const res = await R_getUserInfo()
    return res
});